import axios from 'axios'
import { getInitData } from '../hooks/useTelegram'

export type Language = 'am' | 'ru' | 'en'
export type Service = 'water' | 'gas' | 'electricity'

export interface User {
  id: number
  telegram_id: number
  language: Language
  address: { city: string; street: string }
  notifications: { water: boolean; gas: boolean; electricity: boolean }
}

export interface Alert {
  id: number
  service: Service
  title: string
  body: string
  sent_at: string
}

export interface AlertsList {
  items: Alert[]
  total: number
}

export const apiClient = axios.create({
  baseURL: '/api/v1',
})

apiClient.interceptors.request.use((config) => {
  const initData = getInitData()
  if (initData) {
    config.headers.Authorization = `tma ${initData}`
  }
  return config
})

export async function getMe(): Promise<User> {
  const { data } = await apiClient.get<User>('/me')
  return data
}

export async function updateAddress(city: string, street: string): Promise<User> {
  const { data } = await apiClient.put<User>('/me/address', { city, street })
  return data
}

export async function updateLanguage(language: Language): Promise<User> {
  const { data } = await apiClient.put<User>('/me/language', { language })
  return data
}

export async function updateNotifications(prefs: User['notifications']): Promise<User> {
  const { data } = await apiClient.put<User>('/me/notifications', prefs)
  return data
}

export async function getAlerts(limit = 20, offset = 0): Promise<AlertsList> {
  const { data } = await apiClient.get<AlertsList>('/alerts', {
    params: { limit, offset },
  })
  return data
}
